import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';

const TaskTask = lazy(() => import('./Task'));

export const Task: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<TaskTask {...props} />
	</Suspense>
);
